export const ANCHOR_PAGE_EVENT_NAMES = {
  VIEWED_PAGE: 'Viewed Anchor Page',
  VIEWED_SHARED_PAGE: 'Viewed Shared Library Anchor Page',
  EDITED_GOAL_TEXT: 'Edited Goal Text',
  TOGGLED_ANNUAL_RESOURCES: 'Toggled Annual Resources',
  TOGGLED_QUARTERLY_OBJECTIVES: 'Toggled Quarterly Objectives',
  TOGGLED_SDI_STRATEGIES: 'Toggled SDI Strategies',
  CLICKED_EXAMPLE_CONTENT: 'Clicked Example Content',
  CLICKED_PRINT_SAVED_PAGE: 'Clicked Print Saved Anchor Page',
  VIEWED_SAVED_PAGE: 'Viewed Library Anchor Page',
  CLICKED_SAVE_CHANGES: 'Clicked Save Changes',
  CLICKED_MOVE_TO_TRASH: 'Clicked Move to Trash'
}
